import { connect } from 'react-redux';
import { closeModal as closeModalAction } from 'components/Modal';
import Confirm from './Confirm';

const mapDispatchToProps = {
  closeModal: closeModalAction,
};

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { closeModal } = dispatchProps;

  return {
    ...stateProps,
    ...ownProps,
    onConfirm: ownProps.onConfirm || closeModal.bind(null, true),
    onRequestClose: ownProps.onRequestClose || closeModal.bind(null, false),
  };
}

export default connect(null, mapDispatchToProps, mergeProps)(Confirm);
